import qrCode from "@assets/img-qr-code-app-download-black.png";
import player from "@assets/podcasts/img-podcast-half-player.png";
import { useWindowSize } from "@hooks/useWindowSize";
import { cn } from "@util/helpers";

/**
 * Promote App Download banner version 2. Use in between the keywords stories section.
 */
const PodcastsPromoteBannerVersion2 = (): React.ReactElement => {
  const { isScreenLG } = useWindowSize();

  if (!isScreenLG) return <></>;

  return (
    <div
      className={cn(
        "flex items-center justify-center overflow-hidden bg-gray-150 py-[10px] text-gray-850",
        "-mt-2 mb-10"
      )}
      data-testid="podcasts-promote-banner-version-2-component"
    >
      <div className="flex items-center justify-center">
        <img
          src={qrCode}
          className="block aspect-square w-[70px] rounded-md bg-white p-[5px] md:mx-0"
          width={70}
          height={70}
          alt="QR Code"
        />

        <div className="mx-4 max-w-[236px]">
          <p
            className={cn(
              "mb-1 font-lct text-xs font-bold leading-tight tracking-[0.01em] text-gray-850"
            )}
          >
            Discover a better way to listen
          </p>

          <p className="font-poppins text-4xs font-light text-gray-650">
            {"Scan to try BT's upgraded in-app podcast experience."}
          </p>
        </div>

        <div
          className={cn(
            "rounded-lg border-2 border-gray-175 ring-1 ring-inset ring-gray-175",
            "shadow-[0_6.316px_23.684px_0_rgba(0,0,0,0.08)]",
            "-my-5 w-[150px] rotate-[6deg]"
          )}
        >
          <img
            src={player}
            className="block w-full rounded-lg"
            width={150}
            height={190}
            alt="Podcast Player"
          />
        </div>
      </div>
    </div>
  );
};

export default PodcastsPromoteBannerVersion2;
